// Mirrors backend/homebase/affect_messages/models.py SMS_MAX_LENGTH / EMAIL_MAX_LENGTH.
export const SMS_MAX_LENGTH = 1600;
export const EMAIL_MAX_LENGTH = 10_000;
